import JobZImage from "../../../../common/jobz-img";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { loadScript } from "../../../../../globals/constants";
import axiosInstance from "../../../../../axiosInstance";
import { API_URL } from "../../../../../config";

const getColorClass = (char) => {
    if (!char) return "bg-default";
    const letter = char.toUpperCase();
    const colors = {
        A: "bg-red", B: "bg-blue", C: "bg-green", D: "bg-orange", E: "bg-purple",
        F: "bg-teal", G: "bg-pink", H: "bg-indigo", I: "bg-yellow", J: "bg-cyan",
        K: "bg-lime", L: "bg-rose", M: "bg-amber", N: "bg-violet", O: "bg-emerald",
        P: "bg-fuchsia", Q: "bg-sky", R: "bg-gray", S: "bg-zinc", T: "bg-stone",
        U: "bg-neutral", V: "bg-blue-500", W: "bg-orange-600", X: "bg-indigo-500",
        Y: "bg-pink-600", Z: "bg-teal-600",
    };
    return colors[letter] || "bg-default";
};

function SectionCandidateJobLoops() {
    const { t } = useTranslation();
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        loadScript("js/custom.js");

        const fetchAppliedJobs = async () => {
            try {
                const response = await axiosInstance.get(`${API_URL}/getAllJobLoop`);
                if (response.data.status === 200) {
                    setAppliedJobs(response.data.data);
                }
                console.log("JOB", response);
            } catch (err) {
                console.error("Error fetching applied jobs", err);
            } finally {
                setDataLoaded(true);
            }
        };

        fetchAppliedJobs();
    }, []);

     const recentJobs = appliedJobs.slice(0, 5);

    return (
        <>
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0">{t("Automatic Applications")}</h4>
                </div>
                <div className="panel-body wt-panel-body bg-white">
                    <div className="dashboard-messages-box-scroll scrollbar-macosx">
                        <div className="dashboard-messages-box">
                            {dataLoaded ? (
                                <ul>
                                    {recentJobs.length > 0 ? (
                                        recentJobs.map((job, index) => (
                                            <li key={index}>
                                                <div className="twm-jobs-list-style1 mb-5">
                                                    <div className="twm-media">
                                                        {job.companyLogo ? (
                                                            <JobZImage src={job.companyLogo} alt={job.title} />
                                                        ) : (
                                                            <div className={`company-logo-placeholder ${getColorClass(job.title?.charAt(0))}`}>
                                                                {job.title?.charAt(0)?.toUpperCase() || ''}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="twm-mid-content">
                                                        {/* <NavLink to={`${job.job_url}/${job.id}`} target="_blank" className="twm-job-title"> */}
                                                        <h4 className="twm-job-title">
                                                            {job.title}{" "}
                                                            <span className="twm-job-post-duration">
                                                                / {job.experience.replace("_", " ").replace(/\b\w/g, c => c.toUpperCase())}
                                                            </span>
                                                        </h4>
                                                        {/* </NavLink> */}
                                                        <p className="twm-job-address">{job.location}</p>
                                                        <a href={job.companyWebsite} className="twm-job-websites site-text-primary">
                                                            {job.companyWebsite}
                                                        </a>
                                                        <p>{t("Applied Job")} : {job.total_applied_jobs}</p>
                                                    </div>
                                                    <div className="twm-right-content">
                                                        <div className="twm-jobs-category">
                                                            <span
                                                                className={`${job.job_type === 'Full time'
                                                                    ? 'twm-bg-purple'
                                                                    : job.job_type === 'Contract'
                                                                        ? 'twm-bg-sky'
                                                                        : job.job_type === 'Part time'
                                                                            ? 'twm-bg-golden'
                                                                            : job.job_type === 'Internship'
                                                                                ? 'twm-bg-green'
                                                                                : job.job_type === 'Temporary'
                                                                                    ? 'twm-bg-brown'
                                                                                    : ''}`}
                                                            >
                                                                {job.job_type}
                                                            </span>
                                                        </div>
                                                        <div className="twm-jobs-amount">
                                                            <span>{job.status.toUpperCase()}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))
                                    ) : (
                                        <p>{t("No jobs found.")}</p>
                                    )}
                                </ul>
                            ) : (
                                <p>{t("Loading jobs")}...</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateJobLoops;